/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m8.80761761 25.606596c2.00427859 1.5029947 4.49434739 2.393404 7.19238239 2.393404 6.627417 0 12-5.372583 12-12 0-2.698035-.8904093-5.1881038-2.393404-7.19238239zm-1.49749363-1.3309335 16.96553852-16.96553852c-2.1530299-2.0510262-5.0673072-3.31012398-8.2756625-3.31012398-6.627417 0-12 5.372583-12 12 0 3.2083553 1.25909778 6.1226326 3.31012398 8.2756625zm8.68987602 5.7243375c-7.7319865 0-14-6.2680135-14-14s6.2680135-14 14-14 14 6.2680135 14 14-6.2680135 14-14 14z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;